<template>
  <div class="text-primary l-h-22 grey">
    <h5>Should you run out of qualified specialists, we are here to lend a hand!</h5>
    <p>
      Outsourcing different business operations has long become a new norm for many companies
      around the world. It reduces costs, increases flexibility, and gives you access to a larger
      talent pool. Why not take advantage of it?
    </p>
    <p>
      Our experienced statisticians, programmers, clinical data managers, pharmacovigilance
      scientists, and medical writers are here to help you execute your clinical trial
      operations and complement your in-house team.
    </p>
    <p>
      Take the chance to accelerate your data collection, monitoring, management, and maintenance
      without jeopardizing the quality. Our team will help you cover your pipeline needs while
      you focus on what you do the best.
    </p>
    <p>There is more to FSPs (functional service providers) than one can think of:</p>
    <ul class="ml-4">
      <li>
        Easier access to the skills and expertise that you lack
      </li>
      <li>
        Possibility to use functional service providers only for as long as you need them
      </li>
      <li>
        A reliable collaboration that can prevent you from a single point of failure
      </li>
      <li>
        Faster execution of tasks with efficiency and quality
      </li>
      <li>
        More time to focus on your core specialization
      </li>
      <li>
        Decreased need to waste finances on hiring an in-house team of specialists or having to <br>
        trust individual contractors
      </li>
    </ul>
    <p class="card-ctx">
      Arrange a meeting with one of our specialists now and receive your personalized FSP
      solution to improve your clinical trial process and achieve the expected results.
    </p>
    <b-card-title
      class="title text-primary font-weight-bold f-s-22 l-s-0"
      style="left: 47%"
    >
      {{ modalItem.title }}
    </b-card-title>
  </div>
</template>

<script>
export default {
  name: 'FunctionServiceProviders',
  props: {
    modalItem: {
      type: Object,
      default: () => {},
    },
  },
};
</script>
